import { useCreateSubGoalAllowed as _useCreateSubGoalAllowed } from '@griply/hooks';
import { useGoals } from 'features/goals';
import { useToday } from 'shared/contexts/today';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export const useCreateSubGoalAllowed = () => {
  const goals = useGoals();
  const links = useEntityLinks();
  const user = useUser();
  const today = useToday();

  return _useCreateSubGoalAllowed({ goals, links, user, today });
};
